import React from 'react'
import { storiesOf } from '@storybook/react'

storiesOf('Essentials/Color', module)
  .add('default', () => (
    <a href="https://material-ui.com/style/color/" target="_blank">https://material-ui.com/style/color/</a>
  ))
